import { BASE_URL } from './transport';

export const BASE_IMG_URL = `${BASE_URL}/icons-elon`;

export const NEXT_PUBLIC_BASE_IMAGE_URL =
  'https://casino-games-app.s3.us-west-2.amazonaws.com';
